import Ukiyo from "ukiyojs";

document.addEventListener( 'DOMContentLoaded', function () {
  const parallax = document.querySelector('.ukiyo');

  new Ukiyo(parallax, {
      scale: 1.3, // 1~2 is recommended
      speed: 1.6, // 1~2 is recommended
      willChange: true, // This may not be valid in all cases
      wrapperClass: "ukiyo-wrapper"
  })


})

